export default "__VITE_ASSET__BgRJXtUg__"